import loadScript from '~/assets/services/loadScript';
import { targeo as targeoUrl } from '~/src/config/externalLibsUrl';

const loadTargeoFunctionality = () => new Promise((resolve, reject) => {
    const { Targeo: TargeoRef, TargeoMap: TargeoMapRef, connect: connectRef } = window;

    if (TargeoRef && TargeoMapRef && connectRef) {
        return resolve({
            connect: connectRef,
            Targeo: TargeoRef,
            TargeoMap: TargeoMapRef,
        });
    }

    window.TargeoMapInitialize = () => {
        const { Targeo, TargeoMap, connect } = window;

        resolve({
            connect,
            Targeo,
            TargeoMap,
        });
    };

    loadScript({
        url: targeoUrl,
        fail: reject,
    });
});

export default function (ignore, inject) {
    inject('targeo', loadTargeoFunctionality);
}
